import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DurationTextComponent } from './duration-text.component';
import { NgxVisibilityModule } from 'ngx-visibility';


@NgModule({
  declarations: [
    DurationTextComponent
  ],
  imports: [
    CommonModule,
    NgxVisibilityModule
  ],
  exports: [
    DurationTextComponent
  ]
})
export class DurationTextModule { }
